import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getVideoByVideoIdRpc, getVideoByFileIdRpc } from '../../__generated__/chirp/com/hubspot/video/rpc/HubSpotVideoRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function fetchVideo2(videoId) {
  return rpcClient.call(getVideoByVideoIdRpc, {
    request: {
      videoId
    }
  });
}
export function fetchVideoByFileId(id) {
  return rpcClient.call(getVideoByFileIdRpc, {
    request: {
      sourceFileId: id
    }
  });
}
const MAX_TRIES = 10;
const POLL_INTERVAL_MS = 1000;
const THUMBNAIL_MAX_TRIES = 20;
const THUMBNAIL_POLL_INTERVAL_MS = 2000;
export function pollForVideoThumbnail(videoId) {
  let tries = 0;
  let timeout;
  let cancelled = false;
  const promise = new Promise((resolve, reject) => {
    const tryFetch = () => {
      if (cancelled) {
        return;
      }
      fetchVideo2(videoId).then(video => {
        if (cancelled) {
          return;
        }
        if (video.thumbnailSourceFileId && video.thumbnailUrl) {
          resolve(video.thumbnailUrl);
        } else {
          tries++;
          if (tries < THUMBNAIL_MAX_TRIES) {
            timeout = setTimeout(tryFetch, THUMBNAIL_POLL_INTERVAL_MS);
          } else {
            reject(new Error('Thumbnail not ready after maximum poll attempts'));
          }
        }
      }).catch(() => {
        if (cancelled) {
          return;
        }
        tries++;
        if (tries < THUMBNAIL_MAX_TRIES) {
          timeout = setTimeout(tryFetch, THUMBNAIL_POLL_INTERVAL_MS);
        } else {
          reject(new Error('Failed to fetch video thumbnail'));
        }
      });
    };
    timeout = setTimeout(tryFetch, THUMBNAIL_POLL_INTERVAL_MS);
  });
  return {
    promise,
    cancel: () => {
      cancelled = true;
      clearTimeout(timeout);
    }
  };
}
export function pollForUploadedVideo(fileId) {
  let tries = 0;
  let timeout;
  return new Promise((resolve, reject) => {
    const tryFetch = () => {
      fetchVideoByFileId(fileId).then(data => {
        clearTimeout(timeout);
        resolve(data);
      }).catch(err => {
        tries++;
        if (tries < MAX_TRIES) {
          timeout = setTimeout(tryFetch, POLL_INTERVAL_MS);
        } else {
          reject(err);
        }
      });
    };
    timeout = setTimeout(tryFetch, POLL_INTERVAL_MS);
  });
}